import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import OpenRequest from "./OpenRequest";
import AnsweredRequest from "./AnsweredRequest";
import { useUserStore } from "store/userStore";

const Request: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<"open" | "answered">("open");
  const primaryAirlineCode = useUserStore((state) => state.primaryAirlineCode);

  // Sync tab from sidebar navigation state
  useEffect(() => {
    if (location.state?.tab === "answered") {
      setActiveTab("answered");
    } else if (location.state?.tab === "open") {
      setActiveTab("open");
    }
  }, [location.state]);

  const TabContent = useMemo(
    () => ({
      open: <OpenRequest />,
      answered: <AnsweredRequest />,
    }),
    []
  );

  return (
    <div className="-m-6">
      {/* Breadcrumb */}
      <div className="px-6 pt-5 pb-3 flex items-center gap-2 text-sm">
        <span className="text-[#6B7280]">Requests</span>
        <span className="text-[#9CA3AF]">&gt;</span>
        <span className="text-[#1F2937] font-medium">
          {activeTab === "open" ? "Open" : "Answered"}
        </span>
      </div>

      {/* Content */}
      <div className="px-6">
        {TabContent[activeTab]}
      </div>
    </div>
  );
};

export default Request;
